import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { api } from '../api';

/**
 * Pruh, keď na serveri dochádza miesto.
 *
 * ── Odkiaľ to prišlo ──────────────────────────────────────────────────────
 * 10. septembra 2026 stál celý systém pol dopoludnia. Disk sa zaplnil na
 * 100 %, databáza prestala vedieť zapisovať a aplikácia padala dokola.
 * Zvonku to bola len hláška „HTTP ERROR 502" a príčinu bolo vidieť až
 * z konzoly servera — teda z miesta, kam sa bežne nikto nepozerá.
 *
 * Miesto pritom neubúdalo náhle. Ubúdalo týždne, každú noc o kúsok, a nikto
 * to nemal ako zbadať.
 *
 * ── Prečo to vidí každý, nielen administrátor ─────────────────────────────
 * Plný disk zhodí systém všetkým naraz. Nie je to nastavenie, ktoré patrí do
 * Nastavení — je to blížiaci sa výpadok práce, a ten sa má ukázať tomu, kto
 * pri systéme práve sedí, nech je to ktokoľvek.
 *
 * ── Prečo nie je zavieracie ───────────────────────────────────────────────
 * Lebo zavreté upozornenie na dochádzajúce miesto je to isté ako žiadne.
 * Zmizne samo v okamihu, keď sa miesto uvoľní — a dovtedy je to pravda,
 * ktorú je lepšie mať na očiach.
 */
export default function MiestoNaDisku() {
  const [m, setM] = useState(null);

  useEffect(() => {
    /* Raz pri otvorení a potom raz za pol hodinu. Disk neubúda po sekundách
     * a častejšie pýtanie by bolo len šum. */
    const nacitaj = () => api.get('/api/update/miesto').then(setM).catch(() => {});
    nacitaj();
    const t = setInterval(nacitaj, 30 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  if (!m?.vieme || m.uroven === 'ok') return null;

  const vazne = m.uroven === 'vazne';
  return (
    <div className={`no-print flex items-start gap-2 px-4 py-2 text-sm max-md:py-1.5 max-md:text-xs ${vazne
      ? 'bg-red-600 text-white' : 'bg-amber-100 text-amber-900'}`}>
      <AlertTriangle size={16} className="mt-0.5 shrink-0" />
      <div className="max-md:min-w-0 max-md:truncate">
        <b>{vazne ? 'Na serveri dochádza miesto.' : 'Na serveri ubúda miesto.'}</b>{' '}
        {/* .853 na telefóne len jeden riadok – celé znenie je na počítači */}
        <span className={vazne ? '' : 'max-md:hidden'}>{m.veta}</span>
        {vazne && (
          <span className="ml-1 opacity-90">
            Najčastejšie to bývajú staré nočné zálohy — ozvite sa správcovi skôr,
            než systém prestane fungovať.
          </span>
        )}
      </div>
    </div>
  );
}
